// extracted by mini-css-extract-plugin
module.exports = {"statusNotification":"_2wd1F___UploadStatus-module__statusNotification","error":"_3dFCW___UploadStatus-module__error"};